
import React, { PureComponent } from 'react';
import { connect } from 'react-redux'
import { Route, Redirect, Switch } from 'react-router-dom'
import ListView from './listView'
import MobChartView from './mobChartView'

class Mob extends PureComponent {

  render = () => (
      <Switch>
        <Route path='/mob/coins/:coinId' component={MobChartView}  />
        <Route path='/mob/coins'  component={ListView}  />
        <Redirect to='/mob/coins' />
      </Switch>
  )
}

const mapDispatchToProps = {

}

const mapStateToProps = (state: Store) => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(Mob)



// WEBPACK FOOTER //
// ./src/containers/mob/index.js